import { StepData } from '@/lib/Steppers';

export enum CREATE_DATA_SOURCE_PLUGIN {
  SOURCE_DETAILS,
  TRACK_ACTIVITY,
  INSTALL_PLUGIN,
  CHECK_INSTALLATION,
  INSTALLATION_SUCCESS,
}

export const CREATE_DATA_SOURCE_PLUGIN_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_PLUGIN.SOURCE_DETAILS,
    title: 'data_source_edit:plugin.steps.source_details',
  },
  {
    id: CREATE_DATA_SOURCE_PLUGIN.TRACK_ACTIVITY,
    title: 'data_source_edit:plugin.steps.track_events',
  },
  {
    id: CREATE_DATA_SOURCE_PLUGIN.INSTALL_PLUGIN,
    title: 'data_source_edit:plugin.steps.install_plugin',
  },
  {
    id: CREATE_DATA_SOURCE_PLUGIN.CHECK_INSTALLATION,
    title: 'data_source_edit:plugin.steps.check_installation',
  },
  {
    id: CREATE_DATA_SOURCE_PLUGIN.INSTALLATION_SUCCESS,
    title: 'data_source_edit:plugin.steps.installation_success',
  },
];
